import axiosClient from '../axiosClient';
import { CollectionPointEndpoints } from '../endpoints/collectionPoint';
import { CollectionPointResponse } from '../../types/api/response/collectionpointresponse';
import {
  CreateCollectionPointRequest,
  UpdateCollectionPointRequest,
} from '../../types/api/request/collectionpointrequest';

export const CollectionPointService = {
  async listCollectionPoints(
    warehouseId: number,
    activeOnly?: boolean,
  ): Promise<CollectionPointResponse[]> {
    const res = await axiosClient.get<CollectionPointResponse[]>(CollectionPointEndpoints.LIST, {
      params: { warehouse_id: warehouseId, active_only: activeOnly ?? false },
    });
    return res.data;
  },

  async getCollectionPoint(id: number): Promise<CollectionPointResponse> {
    const url = CollectionPointEndpoints.GET.replace(':id', id.toString());
    const res = await axiosClient.get<CollectionPointResponse>(url);
    return res.data;
  },

  async createCollectionPoint(
    body: CreateCollectionPointRequest,
  ): Promise<CollectionPointResponse> {
    const res = await axiosClient.post<CollectionPointResponse>(
      CollectionPointEndpoints.CREATE,
      body,
    );
    return res.data;
  },

  async updateCollectionPoint(
    id: number,
    body: UpdateCollectionPointRequest,
  ): Promise<CollectionPointResponse> {
    const url = CollectionPointEndpoints.UPDATE.replace(':id', id.toString());
    const res = await axiosClient.put<CollectionPointResponse>(url, body);
    return res.data;
  },
};
